import { render, staticRenderFns } from "./VlModalDossierData.vue?vue&type=template&id=78a57abf&"
import script from "./VlModalDossierData.vue?vue&type=script&lang=js&"
export * from "./VlModalDossierData.vue?vue&type=script&lang=js&"
import style0 from "./VlModalDossierData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports